export const APP_NAME = 'knowledge-product';
export const SCREENS = {
  MANAGE: 'manage-articles',
  ARTICLE_DETAILS: 'article-post-publish',
  CREATE: 'create-article',
  CATEGORIZE: 'categorize',
  INSIGHTS: 'articles-insights',
  TEMPLATE_EDITOR: 'template-editor'
};